import { UserListItemWithStatus as UserListItem } from '$common/user-list-item'
import { MenuIcon } from '$common/icons/menu'
import { usePv } from '$logic/pv/react-hook'

interface Props {
  chatId: string
  hasDivider?: boolean
  onClick?: () => unknown
  onSecondaryActionIconClick: () => unknown
  onContextMenu?: (e: Event) => void
  selected?: boolean
}

export function UserListItemWithStatus({
  chatId,
  onClick,
  hasDivider,
  onSecondaryActionIconClick,
  onContextMenu,
  selected,
}: Props) {
  const { entity: pv } = usePv(chatId)
  return (
    <UserListItem
      userId={pv?.to}
      onClick={onClick}
      hasDivider={hasDivider}
      SecondaryActionIcon={MenuIcon}
      onSecondaryActionIconClick={onSecondaryActionIconClick}
      onContextMenu={onContextMenu}
      selected={selected}
    />
  )
}
